import { useState } from 'react';
import type { SweepNotification } from '../../reducers/notificationsReducer';
import { usePersistentNotificationsContext } from './PersistentNotificationsContext';

const usePersistentNotifications = (): SweepNotification[] => {
  const [dismissedKeys, setDismissedKeys] = useState<Set<string>>(new Set());
  const { notifications } = usePersistentNotificationsContext();

  return notifications
    .filter((notification) => !dismissedKeys.has(notification.key))
    .map((notification) => {
      if (notification.onClose) {
        return notification;
      }
      return {
        ...notification,
        onClose: () => setDismissedKeys((prev) => new Set(prev).add(notification.key)),
      };
    });
};

export default usePersistentNotifications;
